import React, { FC, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import {
  ResourceTableCont,
  ResourceTableHeader,
  ResourceTitle,
  TableContainer,
  TableTitle,
} from './ResourcesTable.styles';
import { ResourcesPerPageOptions } from '../../constans/report';
import { useFilters } from '../../hooks/useFilters';
import { useReportContext } from '../../hooks/useReport';
import GoToPage from '../GoToPage/GoToPage';
import NoData from '../NoData/NoData';
import Pagination from '../Pagination/Pagination';
import { TableFooter } from '../ReportsSetup/ReportSetupTable/ReportsSetupTable.styles';
import RowsPerPage from '../RowsPerPage/RowsPerPage';
import ResourcesTableTile from './ResourcesTableTile/ResourcesTableTile';

const ResourcesTable: FC = () => {
  const { applyFilters } = useFilters();
  const { reportId } = useParams();
  const { t } = useTranslation();

  const { data, meta, getReportResourcesDetails } = useReportContext();

  const { resources } = data ?? {};
  const { resources: metaResources } = meta ?? {};
  const { pageNo, itemsPerPage, totalPageCount } = metaResources ?? {};

  const itemsLength = resources?.length || 0;
  const itemsLengthCond = itemsLength > 0;

  const renderResourcesTableTiles = useMemo(
    () => resources?.map(item => <ResourcesTableTile item={item} key={item?.title} />),
    [resources]
  );

  useEffect(() => {
    (async () => {
      await getReportResourcesDetails(reportId || '0');
    })();
  }, [reportId, getReportResourcesDetails]);

  return (
    <ResourceTableCont id="ResourceTableCont">
      <ResourceTitle id="ResourceTitle">{t('report.results.resources')}</ResourceTitle>
      {itemsLengthCond && meta ? (
        <TableContainer id="TableContainer">
          <ResourceTableHeader id="ResourceTableHeader">
            <TableTitle id="TableTitle">{t('report.results.title')}</TableTitle>
          </ResourceTableHeader>
          {renderResourcesTableTiles}
          {pageNo && itemsPerPage && totalPageCount && (
            <TableFooter id="TableFooter">
              <>
                <RowsPerPage
                  itemsPerPage={itemsPerPage}
                  pagesCount={totalPageCount}
                  menu={ResourcesPerPageOptions}
                />
                <Pagination
                  activePage={pageNo}
                  totalPageCount={totalPageCount}
                  applyFilters={(pageNo: number) => applyFilters({ pageNo: String(pageNo) })}
                />
              </>
              <GoToPage applyFilters={applyFilters} pageLimit={15} />
            </TableFooter>
          )}
        </TableContainer>
      ) : (
        <NoData message={t('report.results.noDataResults')} />
      )}
    </ResourceTableCont>
  );
};

export default ResourcesTable;
